module.exports = __webpack_public_path__ + "img/6_147.ec2a001a.png";